import { useState } from "react";
import { permisos_codigo_id } from "./generales/GroupsId";
import { lang } from "./generales/traduction";
import { capitalizeFirstLetter } from "../utils/utils";

const SideBarMovil = ({
  mode, userPermissions, rolId, onLogin,
  pageSelected, setPageSelected, dataGlobals, languaje
}) => {
  const [pageDesplegado, setPageDesplegado] = useState('')
  const [subPageDesplegado, setSubPageDesplegado] = useState('')
  const [menuMovil, setMenuMovil] = useState('menumovil')

  const toggleMenu = () => {
    (menuMovil === 'menumovil') ? setMenuMovil('menumovilOpen') : setMenuMovil('menumovil')
  }

  // ── Toda la lógica de navegación original intacta ──
  const handleSection = (e) => {
    if (e.target.attributes.name.value != "config" &&
      e.target.attributes.name.value != 'provicionamiento' &&
      e.target.attributes.name.value != "admin" &&
      e.target.attributes.name.value != "reportes" &&
      e.target.attributes.name.value != "mantenimiento" &&
      e.target.attributes.name.value != "respaldo" &&
      e.target.attributes.name.value != "encuestas" &&
      e.target.attributes.name.value != "workflow" &&
      e.target.attributes.name.value != "monitoreo"
    ) {
      if (e.target.attributes.name.value != "config-medDif") {
        setPageSelected(e.target.attributes.name.value);
        toggleMenu()
      } else {
        if (subPageDesplegado == e.target.attributes.name.value) {
          setSubPageDesplegado('')
        } else {
          setSubPageDesplegado(e.target.attributes.name.value)
        }
      }
    } else {
      setSubPageDesplegado('')
      if (pageDesplegado == e.target.attributes.name.value) {
        setPageDesplegado('')
      } else {
        setPageDesplegado(e.target.attributes.name.value)
      }
    }
  };

  const handleSubSection = (e) => {
    if (e.target.attributes.name.value != "config" &&
      e.target.attributes.name.value != "admin" &&
      e.target.attributes.name.value != "reportes" &&
      e.target.attributes.name.value != "mantenimiento" &&
      e.target.attributes.name.value != "respaldo" &&
      e.target.attributes.name.value != "encuestas" &&
      e.target.attributes.name.value != "workflow"
    ) {
      setSubPageDesplegado(e.target.attributes.name.value);
    } else {
      if (pageDesplegado == e.target.attributes.name.value) {
        setSubPageDesplegado('')
      } else {
        setSubPageDesplegado(e.target.attributes.name.value)
      }
    }
  };

  // ── Módulos globales (lógica original) ──
  var estado = "", reportes = 0, cis = 0, acciones = 0, hosts = 0;
  var buzon = 0, portafolio = 0, mantenimiento = 0, configuracion = 0;
  if (dataGlobals.data.data !== undefined) {
    estado = dataGlobals.data.data.find(o => o.name === "estado");
    reportes = dataGlobals.data.data.find(o => o.name === "report_module");
    cis = dataGlobals.data.data.find(o => o.name === "ci_module");
    acciones = dataGlobals.data.data.find(o => o.name === "action_module");
    hosts = 0;
    buzon = dataGlobals.data.data.find(o => o.name === "mail_module");
    configuracion = dataGlobals.data.data.find(o => o.name === "config_module");
    mantenimiento = dataGlobals.data.data.find(o => o.name === "matto_module");
    portafolio = dataGlobals.data.data.find(o => o.name === "portafolio_module");
  }

  // ── Componentes de UI del sistema de diseño ──

  // Item principal con ícono imagen
  const NavItem = ({ name, icon, label, isSection = false, isOpen = false, children }) => {
    const isActive = isSection ? pageDesplegado === name : pageSelected === name;
    return (
      <div style={{ width: '100%' }}>
        <div
          style={{
            display: 'flex', alignItems: 'center',
            justifyContent: 'space-between',
            padding: '7px 14px',
            cursor: 'pointer',
            background: isActive ? 'rgba(26,86,219,.3)' : 'transparent',
            position: 'relative',
            transition: 'background .12s',
            userSelect: 'none'
          }}
          name={name}
          onClick={handleSection}
          onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'rgba(255,255,255,.06)' }}
          onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent' }}
        >
          {/* Barra de acento izquierda cuando está activo */}
          {isActive && (
            <div style={{
              position: 'absolute', left: 0, top: 4, bottom: 4,
              width: 3, background: '#1a56db',
              borderRadius: '0 3px 3px 0'
            }} />
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }} name={name}>
            <div style={{
              width: 15, height: 15,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0, opacity: isActive ? 1 : 0.65
            }} name={name}>
              <img src={icon} name={name}
                style={{ width: 15, height: 15, objectFit: 'contain', filter: 'brightness(10)' }} />
            </div>
            <span style={{
              fontSize: 11, fontWeight: isActive ? 500 : 400,
              color: isActive ? '#fff' : 'rgba(255,255,255,.75)',
              letterSpacing: '.01em'
            }} name={name}>
              {label}
            </span>
          </div>
          {/* Chevron si tiene submenú */}
          {isSection && (
            <div style={{ color: 'rgba(255,255,255,.3)', display: 'flex', alignItems: 'center' }} name={name}>
              <svg width="10" height="10" viewBox="0 0 10 10" name={name}
                style={{ transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform .15s' }}>
                <polyline points="2,3.5 5,6.5 8,3.5" fill="none"
                  stroke="currentColor" strokeWidth="1.4"
                  strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          )}
        </div>
        {/* Submenú */}
        {isOpen && children}
      </div>
    );
  };

  // Sub-item (segundo nivel)
  const SubItem = ({ name, label }) => {
    const isActive = pageSelected === name;
    return (
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 7,
          padding: '6px 14px 6px 38px',
          fontSize: 10,
          color: isActive ? 'rgba(200,220,255,.9)' : 'rgba(255,255,255,.55)',
          fontWeight: isActive ? 500 : 400,
          cursor: 'pointer', transition: 'color .12s',
          userSelect: 'none'
        }}
        name={name}
        onClick={handleSection}
        onMouseEnter={e => { if (!isActive) e.currentTarget.style.color = 'rgba(255,255,255,.8)' }}
        onMouseLeave={e => { if (!isActive) e.currentTarget.style.color = isActive ? 'rgba(200,220,255,.9)' : 'rgba(255,255,255,.55)' }}
      >
        <span style={{
          width: 4, height: 4, borderRadius: '50%',
          background: 'currentColor', flexShrink: 0, opacity: isActive ? 1 : 0.6
        }} />
        <span name={name}>{label}</span>
      </div>
    );
  };

  // Sub-item con chevron (tercer nivel - medios difusión)
  const SubItemExpand = ({ name, label, isOpen }) => {
    const isActive = subPageDesplegado === name;
    return (
      <div
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '6px 14px 6px 38px',
          fontSize: 10,
          color: isActive ? 'rgba(200,220,255,.9)' : 'rgba(255,255,255,.55)',
          cursor: 'pointer', userSelect: 'none', transition: 'color .12s'
        }}
        name={name}
        onClick={handleSection}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 7 }} name={name}>
          <span style={{ width: 4, height: 4, borderRadius: '50%', background: 'currentColor', flexShrink: 0, opacity: .6 }} />
          <span name={name}>{label}</span>
        </div>
        <svg width="9" height="9" viewBox="0 0 10 10" name={name}
          style={{ transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform .15s', color: 'rgba(255,255,255,.3)' }}>
          <polyline points="2,3.5 5,6.5 8,3.5" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    );
  };

  // Sub-sub-item (tercer nivel)
  const SubSubItem = ({ name, label }) => {
    const isActive = pageSelected === name;
    return (
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 7,
          padding: '5px 14px 5px 52px',
          fontSize: 9.5,
          color: isActive ? 'rgba(200,220,255,.9)' : 'rgba(255,255,255,.45)',
          cursor: 'pointer', userSelect: 'none'
        }}
        name={name}
        onClick={handleSection}
      >
        <span style={{ width: 3, height: 3, borderRadius: '50%', background: 'currentColor', flexShrink: 0 }} />
        <span name={name}>{label}</span>
      </div>
    );
  };

  // Etiqueta de sección
  const SectionLabel = ({ children }) => (
    <div style={{
      fontSize: 8, fontWeight: 600, color: 'rgba(255,255,255,.3)',
      textTransform: 'uppercase', letterSpacing: '.09em',
      padding: '8px 14px 3px'
    }}>
      {children}
    </div>
  );

  return (
    <>
      <style>{`
        .sb-scroll::-webkit-scrollbar { width: 3px; }
        .sb-scroll::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 3px; }
        @media (max-width: 500px) {
          .sb-root { height: 5% !important; width: 100% !important; }
          .sb-root.menumovilOpen { height: 90% !important; }
          .sb-menu-icon { display: flex !important; }
          .sb-menu-icon.menumovilOpen { height: 5%; }
          .sb-inner.menumovil { display: none; }
          .sb-inner.menumovilOpen { display: flex; }
          .sb-body { height: 80%; }
        }
      `}</style>

      <div
        className={"sb-root " + menuMovil}
        style={{
          width: '15%',
          background: 'var(--main-color)',
          position: 'absolute', height: '93%',
          display: 'flex', flexDirection: 'column',
          zIndex: 3, transition: 'width .3s ease',
          fontFamily: "'DM Sans', system-ui, sans-serif"
        }}
        id="sidebar"
      >
        {/* Botón móvil */}
        <div
          className={"sb-menu-icon " + menuMovil}
          onClick={toggleMenu}
          style={{
            display: 'none', width: '100%', height: '100%',
            alignItems: 'center', justifyContent: 'center',
            color: '#fff', fontSize: 16, cursor: 'pointer'
          }}
        >
          ☰
        </div>

        {dataGlobals.loading || dataGlobals.error ? '' : (
          <div
            className={"sb-inner " + menuMovil}
            style={{
              width: '100%', height: '100%',
              display: 'flex', flexDirection: 'column'
            }}
          >

            {/* ── LOGO ── */}
            <div style={{
              padding: '12px 14px',
              borderBottom: '1px solid rgba(255,255,255,.08)',
              display: 'flex', alignItems: 'center', gap: 10,
              flexShrink: 0
            }}>
              <div style={{
                width: 30, height: 30, borderRadius: 7,
                background: '#1a56db',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0
              }}>
                {/* <svg width="16" height="16" viewBox="0 0 18 18" fill="none">
                  <circle cx="9" cy="9" r="7" stroke="#fff" strokeWidth="1.4" />
                  <path d="M6 9l2.5 2.5L13 7" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg> */}
                <img src="logo-spin-blanco.png" style={{ width: '60%' }} alt="Logo" />

              </div>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#fff', letterSpacing: '.01em' }}>
                  {/* SaimonTECH */}
                  <img src="SaimonTech_logo_blanco.png" style={{ width: '90%' }} alt="Logo" />
                </div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,.4)', marginTop: 1 }}>
                  Plataforma de monitoreo
                </div>
              </div>
            </div>

            {/* ── NAV BODY ── */}
            <div className="sb-scroll sb-body"
              style={{ flex: 1, overflowY: 'auto', padding: '6px 0' }}>

              {/* Inicio */}
              <NavItem
                name="inicio"
                icon="/iconos/perfil-blanco.png"
                label={capitalizeFirstLetter(lang[languaje]['inicio'])}
              />

              {/* ── Operaciones ── */}
              <SectionLabel>Operaciones</SectionLabel>

              {/* Monitoreo */}
              {userPermissions.some(o => o.permission_id === permisos_codigo_id["monitor"]) && (
                <NavItem
                  name="monitoreo"
                  icon="/iconos/monitoreo-blanco.png"
                  label={capitalizeFirstLetter(lang[languaje]['monitoreo'])}
                  isSection={true}
                  isOpen={pageDesplegado === "monitoreo"}
                >
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["mapa"]) &&
                    <SubItem name="monitor-mapa" label={capitalizeFirstLetter(lang[languaje]['mapa'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["mapa afilicion"]) &&
                    <SubItem name="monitor-mapa-afiliation" label={capitalizeFirstLetter(lang[languaje]['afiliationMapa'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["panel eventos"]) &&
                    <SubItem name="monitor-eventos" label={capitalizeFirstLetter(lang[languaje]['eventos'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["panel dispositivos"]) &&
                    <SubItem name="monitor-indicadores" label={capitalizeFirstLetter('categorias')} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["panel grupos"]) &&
                    <SubItem name="monitor-grupos" label={capitalizeFirstLetter(lang[languaje]['grupos'])} />}
                </NavItem>
              )}



              {/* CMDB */}
              {cis.value == 1 && userPermissions.some(o => o.permission_id === permisos_codigo_id["cis"]) && (
                <NavItem name="cis" icon="/iconos/cis-blanco.png" label={lang[languaje]['cis'].toUpperCase()} />
              )}

              {/* Portafolio */}
              {portafolio.value == 1 && userPermissions.some(o => o.permission_id === permisos_codigo_id["portafolio"]) && (
                <NavItem name="portafolio" icon="/iconos/portafolio-blanco.png" label={capitalizeFirstLetter(lang[languaje]['portafolio'])} />
              )}
              {/* Reportes */}
              {reportes.value == 1 && userPermissions.some(o => o.permission_id === permisos_codigo_id["reportes"]) && (
                <NavItem
                  name="reportes"
                  icon="/iconos/reportes-blanco.png"
                  label={capitalizeFirstLetter(lang[languaje]['reportes'])}
                  isSection={true}
                  isOpen={pageDesplegado === "reportes"}
                >
                  <SubItem name="reporte-disp" label={capitalizeFirstLetter(lang[languaje]['disponibilidad'])} />
                </NavItem>
              )}
              {/* ── Gestión ── */}
              <SectionLabel>Gestión</SectionLabel>

              {/* Administrador */}
              {userPermissions.some(o => o.permission_id === permisos_codigo_id["admin"]) && (
                <NavItem
                  name="admin"
                  icon="/iconos/panel-admin-blanco.png"
                  label={capitalizeFirstLetter(lang[languaje]['admin'])}
                  isSection={true}
                  isOpen={pageDesplegado === "admin"}
                >
                  <SubItem name="admin-rol" label="Roles" />
                  <SubItem name="admin-grupos" label={capitalizeFirstLetter(lang[languaje]['gruposUsuarios'])} />
                </NavItem>
              )}

              {/* Acciones */}
              {acciones.value == 1 && userPermissions.some(o => o.permission_id === permisos_codigo_id["acciones"]) && (
                <NavItem name="acciones" icon="/iconos/acciones-blanco.png" label={capitalizeFirstLetter(lang[languaje]['acciones'])} />
              )}
              {/* Flujo de trabajo */}
              {userPermissions.some(o => o.permission_id === permisos_codigo_id["workflow"]) && (
                <NavItem
                  name="workflow"
                  icon="/iconos/workflow-blanco.png"
                  label={capitalizeFirstLetter(lang[languaje]['workflow'])}
                  isSection={true}
                  isOpen={pageDesplegado === "workflow"}
                >
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["flujo de trabajo"]) &&
                    <SubItem name="workflow-gen" label={capitalizeFirstLetter(lang[languaje]['workflow'])} />}
                </NavItem>
              )}

              {/* Configuración */}
              {configuracion.value == 1 && userPermissions.some(o => o.permission_id === permisos_codigo_id["configuracion"]) && (
                <NavItem
                  name="config"
                  icon="/iconos/config-blanco.png"
                  label={capitalizeFirstLetter(lang[languaje]['config'])}
                  isSection={true}
                  isOpen={pageDesplegado === "config"}
                >
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["agencias"]) &&
                    <SubItem name="config-agency" label={capitalizeFirstLetter(lang[languaje]['agencias'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["criticidades de dispositivos"]) &&
                    <SubItem name="config-criticity" label={capitalizeFirstLetter(lang[languaje]['criticidadDispositivo'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["grupos de dispositivos"]) &&
                    <SubItem name="config-grupos" label={capitalizeFirstLetter(lang[languaje]['gruposDispositivos'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["dispositivos"]) &&
                    <SubItem name="config-hosts" label={capitalizeFirstLetter(lang[languaje]['dispositivos'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["tecnologías"]) &&
                    <SubItem name="config-tec" label={capitalizeFirstLetter(lang[languaje]['tecnologias'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["marcas"]) &&
                    <SubItem name="config-brand" label={capitalizeFirstLetter(lang[languaje]['marcas'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["modelos"]) &&
                    <SubItem name="config-models" label={capitalizeFirstLetter(lang[languaje]['modelos'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["mediciones"]) &&
                    <SubItem name="config-mediciones" label={capitalizeFirstLetter(lang[languaje]['mediciones'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["disparadores"]) &&
                    <SubItem name="config-disparadores" label={capitalizeFirstLetter(lang[languaje]['disparadores'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["eventos"]) &&
                    <SubItem name="config-eventos" label={capitalizeFirstLetter(lang[languaje]['eventos'])} />}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["medios de difusión"]) && (
                    <>
                      <SubItemExpand
                        name="config-medDif"
                        label={capitalizeFirstLetter(lang[languaje]['mediosDifusion'])}
                        isOpen={subPageDesplegado === "config-medDif"}
                      />
                      {subPageDesplegado === "config-medDif" && (
                        <SubSubItem name="config-telegram" label={capitalizeFirstLetter(lang[languaje]['gruposTelegram'])} />
                      )}
                    </>
                  )}
                  {userPermissions.some(o => o.permission_id === permisos_codigo_id["auditor"]) &&
                    <SubItem name="config-audit" label={capitalizeFirstLetter(lang[languaje]['auditor'])} />}
                </NavItem>
              )}
              {/* ── Sistema ── */}
              <SectionLabel>Sistema</SectionLabel>

              {/* Respaldo */}
              {userPermissions.some(o => o.permission_id === permisos_codigo_id["respaldo"]) && (
                <NavItem
                  name="respaldo"
                  icon="/iconos/respaldo-blanco.png"
                  label={capitalizeFirstLetter(lang[languaje]['respaldo'])}
                  isSection={true}
                  isOpen={pageDesplegado === "respaldo"}
                >
                  <SubItem name="respaldo-config" label={capitalizeFirstLetter(lang[languaje]['respaldoConfig'])} />
                </NavItem>
              )}



              {/* Provisionamiento */}
              {userPermissions.some(o => o.permission_id === permisos_codigo_id["provicionamiento"]) && (
                <NavItem
                  name="provicionamiento"
                  icon="/iconos/provicionamiento-blanco.png"
                  label={capitalizeFirstLetter(lang[languaje]['provicionamiento'])}
                  isSection={true}
                  isOpen={pageDesplegado === "provicionamiento"}
                >
                  <SubItem name="provicionamiento-config" label={capitalizeFirstLetter(lang[languaje]['dispositivos'])} />
                  <SubItem name="provicionamiento-soft" label="Software" />
                  <SubItem name="provicionamiento-calendario" label={capitalizeFirstLetter(lang[languaje]['calendarioProvi'])} />
                  <SubItem name="provicionamiento-auditor" label={capitalizeFirstLetter(lang[languaje]['auditor'])} />
                </NavItem>
              )}

            </div>

            {/* ── FOOTER ── */}
            <div style={{
              padding: '10px 14px',
              borderTop: '1px solid rgba(255,255,255,.07)',
              flexShrink: 0
            }}>
              {/* Salir */}
              <div
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  padding: '7px 0', cursor: 'pointer',
                  fontSize: 11, color: 'rgba(255,255,255,.45)',
                  transition: 'color .12s', userSelect: 'none'
                }}
                onClick={onLogin}
                onMouseEnter={e => e.currentTarget.style.color = '#f87171'}
                onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,.45)'}
              >
                <img src="/iconos/log-out-red.svg"
                  style={{ width: 15, height: 15, objectFit: 'contain' }} />
                {capitalizeFirstLetter(lang[languaje]['salir'])}
              </div>
              {/* Versión */}
              <div style={{ fontSize: 9, color: 'rgba(255,255,255,.2)', marginTop: 3 }}>
                V 1.3
              </div>
            </div>

          </div>
        )}
      </div>
    </>
  );
};

export default SideBarMovil;